<app-breadcrumb [title]="title" [breadcrumbs]="breadcrumbs"></app-breadcrumb>
<div class="responses-container">
  <app-responses [groupId]="groupId" [excludeForms]="['user-profile']"></app-responses>
</div>
